// import Vue from 'vue'
import { fb } from '../plugins/firebase'
import { momento } from '../plugins/moment'
import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    reserva: {},
    reservas: [],
    reservasUsuario: [],
    reservasPendientes: []
  },
  mutations: {
    addReserva (state, p) {
      p.comparador = limpiar(p.titulo)
      state.reservas.push(p)
    },
    setReservas (state, p) {
      state.reservas = p
    },
    reservasUsuario (state, p) {
      state.reservasUsuario = p
    },
    completar (state, p) {
      let index = state.reservas.findIndex(sel => sel.id === p)
      if (index !== -1)
        state.reservas[index].completada = true
    },
    eliminarReserva (state, p) {
      let index = state.reservas.findIndex(sel => sel.id === p)
      if (index !== -1)
        state.reservas.splice(index, 1)
    }
  },
  actions: {
    getReservas (ctx) {
      return new Promise ((resolve, reject) => {
        let anio = momento().format('YYYY')
        fb.collection('reservas').where('anio', '==', anio).get()
        .then(results => {
          let all = []
          results.forEach(doc => {
            let item =  doc.data()
            item.id = doc.id
            item.comparador = limpiar(item.titulo)
            all.push(item)
          })
          let final = all.sort((a, b) => momento(b.timestamp).format('x') - momento(a.timestamp).format('x'))
          ctx.commit('setReservas', final)
          resolve(final)
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    reservar (ctx,p) {
      return new Promise ((resolve, reject) => {
        p.timestamp = momento().format()
        fb.collection('reservas').add(p)
        .then(resp => {
          p.id = resp.id
          resolve(p)
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    verReservasUsuario (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('reservas').where('usuario', '==', p).get()
        .then(results => {
          let all =[]
          results.forEach(doc => {
            let item = doc.data()
            item.id = doc.id
            all.push(item)
          })
          let final = all.sort((a, b) => momento(b.timestamp).format('x') - momento(a.timestamp).format('x'))
          ctx.commit('reservasUsuario', final)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    completarReserva (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('reservas').doc(p.id).update({completada: true, completadael: momento().format()})
        .then(() => {
          ctx.commit('completar', p.id)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    eliminar (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('reservas').doc(p.id).delete()
        .then(() => {
          ctx.commit('eliminarReserva', p.id)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    }
  },
  getters: {
    reservas: (state) => state.reservas,
    reservasUsuario: (state) => state.reservasUsuario,
    reservasPendientes: (state) => state.reservas.filter(sel => !sel.completada)
  }
}
